<template>
  <!-- 外部ユーザー検索 -->
  <div id="ExternalUserSearchContent">
    <div class="condition-area">
        <table class="conditionTable">
        <tr>
            <th>組織ID</th>
            <td><input type="text" class="validate" validate="numericBelongs" name="belongsId" v-model="searchConditions.belongsId" maxlength="9"/></td>
            <!-- <td><input type="text" v-model="searchConditions.belongsId"/></td> -->
            <th>組織名</th>
            <td><input type="text" v-model="searchConditions.orgName"  maxlength="100"/></td>
            <th>ユーザーID</th>
            <td><input type="text" class="validate" validate="numeric" name="ID" v-model="searchConditions.userId" maxlength="9"/></td>
            <th>ユーザー名</th>
            <td><input type="text" v-model="searchConditions.name" maxlength="100"/></td>
        </tr>
        <tr>
          <th>種別</th>
            <td><select v-model="searchConditions.kind">
                  <option value=""></option>
                  <option :value="role.role_hospital">医療機関</option>
                  <option :value="role.role_corporation" v-if="roleId!=role.role_salesOffice">企業</option>
                  <option :value="role.role_dealer">ディーラー</option>
                  <option :value="role.role_judgment" v-if="roleId!=role.role_salesOffice">判定医療機関</option>
                  <option :value="role.role_analysis" v-if="roleId!=role.role_salesOffice">解析委託業者</option>
                  <option :value="role.role_accommodations" v-if="roleId!=role.role_salesOffice">宿泊施設</option>
                  </select>
            </td>
          <th>状態</th>
            <td><select v-model="searchConditions.status">
                  <option value=""></option>
                  <option :value="extUserStatus.registed">本登録</option>
                  <option :value="extUserStatus.brunchReview">支店回送中</option>
                  <option :value="extUserStatus.tempReg">仮登録中</option>
                  <option :value="extUserStatus.addRequest">追加依頼中</option>
                </select>
            </td>
          <th>連絡先</th>
            <td><input type="text" v-model="searchConditions.phoneNumber" maxlength="100"/></td>
          <th>メール<br>アドレス</th>
            <td><input type="text" v-model="searchConditions.mail" maxlength="100"/></td>            
        </tr>
        <tr>
            <th>担当支店</th>
            <td>
              <select v-model="searchConditions.branchOfficeCode">
                <option v-for="branch in branchList" :value="branch.code" :key="branch.code">{{ branch.name }}</option>
              </select>
            </td>
            <th>営業担当者</th>
            <td><input type="text" v-model="searchConditions.salesStaffName" maxlength="100"/></td>
            <th>未設定施設<br>(ディーラー)</th>
            <td><select v-model="searchConditions.branchEndSettingDealer">
                  <option value=""></option>
                  <option value="1">未設定の施設あり</option>
                </select>
            </td>
            <th>メール<br>配信エラー</th>
            <td><select v-model="searchConditions.mailDeliveryError">
                    <option value=""></option>
                    <option value="1">エラーのみ</option>
                  </select>
            </td>
        </tr>
        <tr>
            <th>CO利用状況</th>
            <td>
              <select v-model="searchConditions.coUseStatus">
                <option :value="0"></option>
                <option :value="coUse.notUse">未利用</option>
                <option :value="coUse.waitting">申請待ち</option>
                <option :value="coUse.registed">登録待ち</option>
                <option :value="coUse.inUse">利用中</option>
              </select>
            </td>
        </tr>
        </table>
        <div class="searchButton-area" style="margin-bottom:10px;">
        <b-button class="is-primary" @click="doSearch">検索</b-button>
        <b-button v-if="roleId==role.role_admin || roleId==role.role_headOffice || roleId==role.role_headOffice_division" class="backButton is-primary" @click="addUser">外部ユーザー追加</b-button>
        </div>
    </div>
    <!-- 検索結果 -->
    <div class="result-area" style="width:1450px;" v-if="data.length > 0">
      <span class="result-count">件数：{{data.length}}件</span>
      <b-table
          id="externalUserSearchContentTable"
          :data="data"
          :paginated="true"
          per-page="100"
          pagination-position="both"
          default-sort="user.first_name"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
        >
        <template slot-scope="props">
            <b-table-column field="belongsId" label="組織ID" width="100" sortable centered>
              <router-link :to="{name:'ExternalUserEdit', query:{from:encodeURIComponent(from), uid:encodeURIComponent(props.row.userId)}, params:{searchConditions: searchConditions}}">
                {{props.row.belongsId}}
              </router-link></b-table-column>
            <b-table-column field="orgName" label="組織名" width="200" sortable>{{props.row.orgName}}</b-table-column>
            <b-table-column field="division" label="診療科名・部署名" width="220" sortable>{{props.row.division}}</b-table-column>
            <b-table-column field="userId" label="ユーザーID" width="150" sortable centered>{{props.row.userId}}</b-table-column>
              <!-- <router-link :to="{name:'ExternalUserEdit', query:{from:encodeURIComponent(from), uid:encodeURIComponent(props.row.userId)}, params:{searchConditions: searchConditions}}">
                {{props.row.userId}}
              </router-link></b-table-column> -->
            <b-table-column field="name" label="ユーザー名" width="200" sortable>{{props.row.name}}</b-table-column>
            <b-table-column field="kind" label="種別" width="150" sortable>{{props.row.kind | roleFilter}}<span v-if="props.row.branchEndSettingDealer == '1'" class="facilityError"/></b-table-column>
            <b-table-column field="mail" label="メールアドレス" width="200" sortable>{{props.row.mail | mailFilter}}<span v-if="props.row.mailDeliveryError == '1'" class="mailError" /></b-table-column>
            <b-table-column field="phoneNumber" label="連絡先" width="120" sortable>{{props.row.phoneNumber}}</b-table-column>
            <b-table-column field="branchOfficeCode" label="担当支店" width="120" sortable>{{props.row.branchOfficeName}}</b-table-column>
            <b-table-column field="salesStaffName" label="営業担当者" width="130" sortable>{{props.row.salesStaffName}}</b-table-column>
            <b-table-column field="status" label="状態" width="100" centered sortable>
            <span :class="getTagClass4ExtUserStatus(props.row.status)">
                {{props.row.status | extUserStatusFilter}}
            </span>
            </b-table-column>
            <b-table-column field="tempRegDate" label="仮登録日" width="160" sortable>{{props.row | tempRegDateFilter}}</b-table-column>
            <b-table-column field="addRequestDate" label="ユーザー追加依頼日" width="160" sortable>{{props.row | addRequestDateFilter}}</b-table-column>
            <b-table-column field="brunchReviewDate" label="支店回送日" width="160" sortable>{{props.row | brunchReviewDateFilter}}</b-table-column>
            <b-table-column field="registedDate" label="本登録日" width="160" sortable>{{props.row | registedDateFilter}}</b-table-column>
            <b-table-column field="hstStatus" label="HST検査" width="120" sortable>{{props.row | hstInUseFilter}}</b-table-column>
            <b-table-column field="psgStatus" label="PSG解析" width="120" sortable>{{props.row | psgInUseFilter}}</b-table-column>
            <b-table-column field="coStatus" label="CO" width="120" sortable>{{props.row | coInUseFilter}}</b-table-column>
            <b-table-column field="cpapStatus" label="CPAP" width="120" sortable>{{props.row | cpapInUseFilter}}</b-table-column>
            <b-table-column field="holterStatus" label="ホルター検査" width="120" sortable>{{props.row | holterUseFilter}}</b-table-column>
            <b-table-column field="holterDepositStatus" label="ホルター院内貸出" width="120" sortable>{{props.row | holterDepositUseFilter}}</b-table-column>
            <b-table-column field="inspectionReportStatus" label="呼吸点検報告書" width="120" sortable>{{props.row | inspectionReportUseFilter}}</b-table-column>
        </template>
       </b-table>
    </div>
    <div class="result-area" v-if="dataBlank && data.length == 0">
      <div class="result-count">件数：{{data.length}}件</div>
    </div>

  </div>
</template>

<script>
import {role} from "@/components/mock/base/const.js";
import {extUserStatus} from "@/components/mock/base/const.js";
import {coUse} from "@/components/mock/base/const.js";
import {coStatus} from "@/components/mock/base/const.js";
import {coStatusStr} from "@/components/mock/base/const.js";
import {service} from "@/components/mock/base/const.js";
const RELEASE_DATE_FOR_REGIST_STATUS_DATE = '2025/04/19'
export default {
  name: "ExternalUserSearchContent",
  props: ["from", "preSearchConditions"],
  methods: {
    getStatusStr: function(status) {
      const targetStatusKey = Object.keys(coStatus).filter((key)=>coStatus[key]===status.toString(10))[0]
      return coStatusStr[targetStatusKey]
    },
    doSearch: function() {
      var elements = document.getElementsByClassName("validate")
      var result = this.selfMadeValidation(elements)
      var errMsg = result.msg
      if(result.isError){
        this.showErrorMessage(errMsg)
      }else if (errMsg != ""){
        this.showErrorMessage(errMsg)
      }else{
        // Web Api Call
        var _this = this;
        this.apiCall(
          function(client){
            _this.searchConditions.kindArry = [];
            if(_this.searchConditions.kind != ""){
              _this.searchConditions.kindArry = [_this.searchConditions.kind];
            } else {
              if(_this.roleId == _this.role.role_salesOffice){
                _this.searchConditions.kindArry = [_this.role.role_hospital,_this.role.role_dealer]
              }
            }
            var obj = JSON.parse(JSON.stringify(_this.searchConditions));
            return client.apis.internalMaintenance.getMaintenanceExternalUserListPOST({
              body:obj
            });
          },
          function(result){
            _this.data = result.obj
            _this.dataBlank = true;
          },
          function(result){
            _this.showErrorMessage(result);
          }
        );
      }
    },
    addUser: function(){
      this.$router.push({
        name: "ExternalUserAdd",
        params: {from:this.from,  searchConditions:this.searchConditions}
      });
    }
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var branchList = this.getBranchOfficeMaster();
    branchList.unshift({});
    return {
      role: role,
      roleId: userInfo.roleId,
      service: service,
      extUserStatus:extUserStatus,
      searchConditions:{
        userId:"",
        kind:"",
        kindArry:[],
        status:"",
        orgName:"",
        name:"",
        mail:"",
        mailDeliveryError:"",
        phoneNumber:"",
        branchEndSettingDealer:"",
        branchOfficeCode:"",
        salesStaffName:"",
        coUseStatus:0,
        belongsId:"",
        dataBlank:false
      },
      data: [],
      branchList,
      coUse: coUse,
    };
  },
  filters: {
    mailFilter: function(value) {
      if(value.startsWith("なし")){
        return "なし";
      } else {
        return value;
      }
    },
    tempRegDateFilter: function(row){
      if(row.tempRegDate){
        return row.tempRegDate
      } else if(row.createdAt < RELEASE_DATE_FOR_REGIST_STATUS_DATE) {
        return "－";
      } else {
        return "";
      }
    },
    addRequestDateFilter: function(row){
      if(row.addRequestDate){
        return row.addRequestDate
      } else if(row.createdAt < RELEASE_DATE_FOR_REGIST_STATUS_DATE) {
        return "－";
      } else {
        return "";
      }
    },
    brunchReviewDateFilter: function(row){
      if(row.brunchReviewDate){
        return row.brunchReviewDate
      } else if(row.createdAt < RELEASE_DATE_FOR_REGIST_STATUS_DATE
        && (row.status == extUserStatus.brunchReview || row.status == extUserStatus.registed)) {
        return "－";
      } else {
        return "";
      }
    },
    registedDateFilter: function(row){
      if(row.registedDate){
        return row.registedDate
      } else if(row.createdAt < RELEASE_DATE_FOR_REGIST_STATUS_DATE && row.status == extUserStatus.registed) {
        return "－";
      } else {
        return "";
      }
    },
    //HSTの利用状況
    hstInUseFilter: function(row){
      if(row.status != extUserStatus.registed){
        //本登録以外は全て"－"
        return "－";
      } else if(row.kind != role.role_hospital && row.kind != role.role_dealer ){
        //医療機関、ディーラー以外は全て"－"
        return "－";
      } else {
        //利用サービスHSTが有効な場合は”利用中、無効な場合は”未利用”
        return (row.useServiceId & service.hst) == service.hst?"利用中":"未利用";
      }
    },
    //PSGの利用状況
    psgInUseFilter: function(row){
      if(row.status != extUserStatus.registed){
        //本登録以外は全て"－"
        return "－";
      } else if(row.kind != role.role_hospital && row.kind != role.role_dealer ){
        //医療機関、ディーラー以外は全て"－"
        return "－";
      } else {
        //利用サービスPSGが有効な場合は”利用中、無効な場合は”未利用”
        return (row.useServiceId & service.psg) == service.psg?"利用中":"未利用";
      }
    },
    //ケアオケの利用状況
    coInUseFilter: function(row){
      if(row.status != extUserStatus.registed){
        //本登録以外は全て"－"
        return "－";
      } else if(row.kind != role.role_hospital ){
        //医療機関以外は全て"－"
        return "－";
      } else {
        let retValue = ""
        if(row.coCount > 0){
          //CO申請件数が1件以上の場合は"利用中"
          retValue = "利用中";
        } else {
          //CO申請件数が0件
          if(row.coInUse == coUse.registed){
            //申込み時に「既に利用中」を選択された場合、”登録待ち”
            retValue = "登録待ち";
          } else if(row.coInUse == coUse.notUse){
            //申込み時に「今は利用しない」を選択された場合、”未利用”
            retValue = "未利用";
          } else if(row.coInUse == coUse.waitting){
            //申込み時に「始めて利用する」を選択された場合、”申請待ち”
            retValue = "申請待ち";
          } else{
            retValue = "未利用";
          }
        }
        return retValue;
      }
    },
    //CPAPの利用状況
    cpapInUseFilter: function(row){
      if(row.status != extUserStatus.registed){
        //本登録以外は全て"－"
        return "－";
      } else if(row.kind != role.role_hospital && row.kind != role.role_dealer ){
        //医療機関、ディーラー以外は全て"－"
        return "－";
      } else {
        //利用サービスCPAPが有効な場合は”利用中、無効な場合は”未利用”
        return (row.useServiceId & service.cpap) == service.cpap?"利用中":"未利用";
      }
    },
    //ホルターの利用状況
    holterUseFilter: function(row){
      if(row.status != extUserStatus.registed){
        //本登録以外は全て"－"
        return "－";
      } else if(row.kind != role.role_hospital && row.kind != role.role_dealer ){
        //医療機関、ディーラー以外は全て"－"
        return "－";
      } else {
        //利用サービスホルター検査配送ｻｰﾋﾞｽが有効な場合は”利用中、無効な場合は”未利用”
        return (row.useServiceId & service.holter) == service.holter?"利用中":"未利用";
      }
    },
    holterDepositUseFilter: function(row){
      if(row.status != extUserStatus.registed){
        //本登録以外は全て"－"
        return "－";
      } else if(row.kind != role.role_hospital && row.kind != role.role_dealer ){
        //医療機関、ディーラー以外は全て"－"
        return "－";
      } else {
        //ホルター院内貸出が有効な場合は”利用中、無効な場合は”未利用”
        return row.holterUseDepositFlg?"利用中":"未利用";
      }
    },
    //呼吸点検報告書の利用状況
    inspectionReportUseFilter: function(row){
      if(row.status != extUserStatus.registed){
        //本登録以外は全て"－"
        return "－";
      } else if(row.kind != role.role_hospital && row.kind != role.role_dealer ){
        //医療機関、ディーラー以外は全て"－"
        return "－";
      } else {
        //利用サービス呼吸点検報告書が有効な場合は”利用中、無効な場合は”未利用”
        return (row.useServiceId & service.inspection_report) == service.inspection_report?"利用中":"未利用";
      }
    },
  },
  components: {},
  mounted: function(){
    if(this.preSearchConditions){
      this.searchConditions = this.preSearchConditions;
      this.doSearch();
    }
  }
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
input {
  width: 200px;
}
.tag {
  width: 100px;
}
.facilityError,
.mailError
{
  position:relative;
}

</style>


// WEBPACK FOOTER //
// src/components/mock/philips/master/user/ExternalUserSearchContent.vue